import { render, staticRenderFns } from "./demand-zb.vue?vue&type=template&id=3ad6f0a0"
import script from "./demand-zb.vue?vue&type=script&lang=js"
export * from "./demand-zb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports